module.exports = __webpack_public_path__ + "static/media/contact-by-email.83ae7df6.png";